/**
 * ExternalCalendarsSection — hub for external calendar sync (#349, #350).
 *
 * Currently ships with Google Calendar (OAuth) and Apple Calendar
 * (CalDAV + app-specific password). Microsoft Calendar was scoped in
 * A2 (#353) but pulled before launch to keep the surface tight. Adding
 * it back later is a two-line insert here plus a PROVIDERS entry in
 * OAuthCallback.tsx and re-enabling the microsoft-calendar-sync edge
 * function.
 */

import GoogleCalendarSettings from './GoogleCalendarSettings';
import AppleCalendarSettings from './AppleCalendarSettings';
import { GOOGLE_CALENDAR_SHIPPED } from '@/config/launch';

export default function ExternalCalendarsSection() {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-foreground">External calendars</h3>
        <p className="text-sm text-muted-foreground">
          {/* LAUNCH-5 — Google is held until its OAuth app is set up
              (GOOGLE_CALENDAR_SHIPPED); offering it could only fail. */}
          {GOOGLE_CALENDAR_SHIPPED
            ? 'Connect Google or Apple Calendar. Orbit events push out both ways so you never double-book.'
            : 'Connect Apple Calendar. Orbit events push out both ways so you never double-book.'}
        </p>
      </div>
      {GOOGLE_CALENDAR_SHIPPED && <GoogleCalendarSettings />}
      <AppleCalendarSettings />
    </div>
  );
}
